module.exports = __webpack_public_path__ + "media/images/logo_rvb-8a3b605760840fa4263eb8a652d8812a.svg";